import * as React from 'react';

import Group from 'sail/Group';
import {AttentionNotice, NegativeNotice, PositiveNotice} from 'sail/Notice';

// TODO add some sort of script that generates the source code
// given a rendered preview

const presets = {
  rendered: (
    <Group spacing={20}>
      <AttentionNotice
        title="Attention notice"
        description="Automatically sets the icon to a warning circle and the color to yellow."
      />

      <NegativeNotice
        title="Negative notice"
        description="Automatically sets the icon to a warning triangle and the color to red."
      />

      <PositiveNotice
        title="Positive notice"
        description="Automatically sets the icon to a checkmark and the color to green."
      />
    </Group>
  ),
  source: `<Group spacing={20}>
  <AttentionNotice
    title="Attention notice"
    description="Automatically sets the icon to a warning circle and the color to yellow."
  />

  <NegativeNotice
    title="Negative notice"
    description="Automatically sets the icon to a warning triangle and the color to red."
  />

  <PositiveNotice
    title="Positive notice"
    description="Automatically sets the icon to a checkmark and the color to green."
  />
</Group>`,
};

export {presets};
